import * as React from "react";
import { Box, Button, Typography,Grid2, CircularProgress, useMediaQuery, IconButton } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import SignUpBg from "../../../../Assets/Images/Signup_web.png";
import { useSelector, useDispatch } from 'react-redux';
import { checkAndNavigate, retakeFaceMatchApi, generateQR, retakeLiveness, retakeConfirm, setActiveStep } from "../../../../Redux/usersSlice";
import icon from "../../../../Assets/Images/icon.svg"
import CaptureStyles from "../Capture.module.css"
import success from "../../../../Assets/Images/bvsuccess.svg"
import CaptureStyles1 from "../capturePhotoStyle.module.css";
import img from "../../../../Assets/Images/Capture.png"
import navLogo from "../../../../Assets/Images/logo.svg"
import SignatureStyles from "../../Signature/Signature.module.css"
import Webcam from "react-webcam";
import { publicIpv4} from 'public-ip';
import io from "socket.io-client";
import { QRCodeCanvas } from "qrcode.react";
import LinearProgress from '@mui/material/LinearProgress';
import { ArrowBack } from "@mui/icons-material";
import CryptoJS from "crypto-js";
const webcamRef = React.createRef(null);
export default function CaptureRetakeSelfie() {
  const navigate = useNavigate();
  const location = useLocation();
  const SOCKET_SERVER_URL = window.location.hostname.includes("localhost") || window.location.hostname.includes("staging") ? "https://admin-backend-staging.tradeboss.co" : "https://admin-backend.tradeboss.co"

  const dispatch = useDispatch();

  const [openCamera, setOpenCamera] = React.useState(false)
  const [capturedImage, setCapturedImage] = React.useState(null);
  const [matchScore , setMatchScore] = React.useState(0)
  const [livelinessScore , setLivelinessScore] = React.useState(0)
  const [socket, setSocket] = React.useState(null);
  const [isQRMode, setIsQRMode] = React.useState(false);
  const [qrURL, setQrURL] = React.useState("");
  const [error,setError] = React.useState(false)
  const [errorMessage,setErrorMessage] = React.useState("")
  const [isCompleted,setIsCompleted] = React.useState(false)
  const [isLoading ,setIsLoading] = React.useState(false)
  const [passed,setPassed] = React.useState(false)
  const [checkStatus,setCheckStatus] = React.useState(false)
 
   const { retakeAuth } = useSelector(state => state.user);
 const [user, setUser] = React.useState({
        mobile: "",
        email: "",
        user_id: ""
    })


    //  const theme = useTheme();
     const isMobile = useMediaQuery('(max-width:1000px)');

  const screen768px = useMediaQuery("(max-width : 768px)")
  const isSmallScreen = useMediaQuery("(max-width : 600px)")

  // Sync step with URL path


  const params = new URLSearchParams(window.location.search)
      
      React.useEffect(() => {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "kyc_step_viewed",
          step_name: "retake_selfie_page_viewed",
          page_path: window.location.pathname
        });
      }, [])


  React.useEffect(() => {
    if (!retakeAuth?.mobile) return;

    const fetchSignatureStatus = async () => {
    
      try {
        console.log("heeloowww")
        const response = await dispatch(
          retakeConfirm({
            mobile: retakeAuth.mobile,
            email: retakeAuth.email,
            type: "selfie"
          })
        ).unwrap();
        console.log("heeloowww1",response?.data)
        const status = response?.data?.data?.success;

        if (status) {
          setIsCompleted(true);
          if (isQRMode) {
            setQrURL("");
            setIsQRMode(false);
            setErrorMessage("");
          }
        } else {
          if (isQRMode) {
            setErrorMessage("Your selfie is still pending !!");
          }
        }
      } catch (err) {
        console.log(err);
      }
    };

    fetchSignatureStatus();
  }, [checkStatus, retakeAuth]);


  React.useEffect(() => {
    if (!isQRMode) return;

    const socketInstance = io(SOCKET_SERVER_URL, { transports: ["websocket"] });
    setSocket(socketInstance);

    socketInstance.on("connect", () => {
        console.log("Connected to Socket.io server with ID:", socketInstance.id);
    });

    setTimeout(() => {
        const registrationPayload = {
          email: retakeAuth?.email,
          mobile: retakeAuth?.mobile,
          socket_id: socketInstance.id,
          stage: "Selfie"
        };
        socketInstance.emit('register', registrationPayload);
        localStorage.setItem("socket_id", socketInstance.id);
    }, 2500);

    socketInstance.on("signature-status", (message) => {
        window.location.assign(message);
    });

    return () => {
      socketInstance.disconnect();
      console.log('Disconnected from Socket.io server');
    };

}, [isQRMode]);

  

  const handleGenerateQR = async () => {
    setErrorMessage("")
    setPassed(false)
    setCapturedImage(null)
    if(isQRMode){
      setIsQRMode(false)
      return
    }

    try {
      const response = await dispatch(generateQR({ mobile: retakeAuth?.mobile, email: retakeAuth?.email, source: "Selfie_retake" })).unwrap();
        setQrURL(response?.data?.url);
        setIsQRMode(true);
    } catch (error) {
        console.error('Failed to generate QR:', error);
    }
};

  console.log("qrURL",qrURL)



 const handleCapture = async () => {
    setIsLoading(true)
    setError(false)
    setErrorMessage("")
    setLivelinessScore(0)
    setMatchScore(0) 

    if(capturedImage){
      setCapturedImage(false)
      setIsLoading(false)
      return
    }
    
    let imageSrc = webcamRef.current.getScreenshot({ width: 1280, height: 720, dpi: 96 });
    let device="Desktop"
    if(screen768px){
       imageSrc = webcamRef.current.getScreenshot({ width: 720, height: 1000, dpi: 96 });
       device="Mobile"
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "kyc_step_viewed",
      step_name: "retake_selfie_captured",
      page_path: window.location.pathname
    });
    if (imageSrc) {
      setCapturedImage(imageSrc); 

      try{
        const faceVerify = await dispatch(retakeFaceMatchApi({ mobile: retakeAuth?.mobile, email: retakeAuth?.email,selfieImage : imageSrc,device})).unwrap()
        console.log(faceVerify?.data?.data , "face")
        const data = faceVerify?.data?.data
        console.log(data , data?.success , "success")
        if(data?.success == true && data.code !== "3"){
          setMatchScore(data?.similarity)
          const ip = await publicIpv4()
          const livenessVerify = await dispatch(retakeLiveness({ mobile: retakeAuth?.mobile, email: retakeAuth?.email, selfieImage: imageSrc, ip: ip, device})).unwrap()
          const livenessResult = livenessVerify?.data?.data
          console.log(livenessResult, "livenessResult")
          if(livenessResult?.success){
            console.log(livenessResult?.score, "livenessResult")
            setLivelinessScore(livenessResult?.score)
            setPassed(true)
          }else{
            setError(true)
            setErrorMessage(livenessResult?.message)
          }
          setIsLoading(false)
        }else{
          setError(true)
          setErrorMessage(data.message)
        }
        setIsLoading(false)
      }catch(error){
        setError(true)
        setIsLoading(false)
        setErrorMessage(error?.data?.data?.message)
      } 

    }
    console.log("Captured Base64 Image:", imageSrc); 
  }

   console.log("isComplete",isCompleted)

  return ( 
    <>
       <Box sx={{
          display: "flex",
          minHeight: "100vh !important",
          flexDirection: isMobile ? "column" : "row",
          backgroundImage: `url(${SignUpBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}>

          {/* <Typography
        sx={{
          textAlign: "center",
          fontSize: "16px",
          fontFamily: "Inter400",
          display: {
            xs: "block", // shown on small screens
          },
          mt: "5px",
          "@media (min-width:1000px)": {
            display: "none"
          }
        }}
      >
        {`You are on step ${activeStep + 1} out of 8`}
      </Typography> */}



          {isCompleted &&
            <Box className={SignatureStyles.content_wrapper}>
              <Grid2 flexDirection="column" display="flex" justifyContent="center" alignItems="center" height="600px" width="100%">
                <img src={success} alt="successLogo" />
                <Typography className={SignatureStyles.title}>Your selfie has been captured successfully</Typography>
                {/* <Grid2 className={SignatureStyles.card}>
                  <Button onClick={() => {
                    setIsCompleted(false)
                    setCapturedImage(null)
                    setPassed(false)
                  }} className={CaptureStyles.skip}>
                    Edit
                  </Button>
                  <Button className={CaptureStyles.submit} onClick={handleNextLogic}>
                continue
              </Button>
                </Grid2> */}
              </Grid2>

            </Box>
          }

          {/* Your content area */}
          {!isCompleted && <>
            {openCamera ? <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                // justifyContent: "center",
              }}
            >
              <Typography
                sx={{
                  color: "#481B9D",
                  fontSize: "48px",
                  fontFamily: "Inter900",
                  paddingTop: "70px",
                  marginBottom: "10px",
                  textAlign: "center",
                  padding: "20px",

                }}
                className={CaptureStyles1.heading}
              >
                Stay still and Capture now
              </Typography>
              <Grid2>
                {!isQRMode ? <div
                  className={CaptureStyles1.img_container}
                // style={{
                //   width: "267px",
                //   height: "273px",
                //   border: "8px solid #1CF400",
                //   borderRadius: "50%",
                //   overflow: "hidden",
                //   position: "relative",
                //   display: "flex",
                //   justifyContent: "center",
                //   "@media  screen and (max-width:600px)": {
                //     width: "200px",
                //     height: "200px",
                //   }
                // }}
                >
                  {capturedImage ? (
                    <img
                      src={capturedImage}
                      alt="Captured"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }}
                    />
                  ) : (
                    <Webcam
                      className={CaptureStyles1.web_cam}
                      // style={{ objectFit: "cover",
                      //     width: "300px",
                      //     height: "300px",
                      //     "@media  screen and (max-width:600px)": {
                      //       width: "200px",
                      //       height: "200px",
                      //     }
                      //  }}
                      screenshotFormat="image/jpeg"
                      screenshotQuality={1}
                      imageSmoothing={true}
                      mirrored={true}


                      ref={webcamRef}
                    />
                  )}
                </div> :
                  <Grid2>
                    <Typography className={SignatureStyles.sub_title}>Scan This QR on your Phone</Typography>
                    <Grid2 className={SignatureStyles.qrCodeGrid}>
                      <QRCodeCanvas value={qrURL} size={159} />
                    </Grid2>
                  </Grid2>}
              </Grid2>
              {capturedImage && <Grid2 sx={{ display: 'flex', justifyContent: "space-between", alignItems: "center", width: "300px", marginTop: "20px" }}>
                {isLoading ? <Box sx={{ width: '100%' }}>
                  <LinearProgress />
                </Box> :
                  <>
                    <Typography>
                      Face Match - {matchScore > 0 ? `${matchScore.toFixed(2)}%` : "NA"} {/* if NA , Face match is skiped */}
                    </Typography>
                    <Typography sx={{ marginLeft: "5px" }} >liveness - {livelinessScore?.toFixed(2)}%</Typography></>}
              </Grid2>}
              {/* // With this simplified version: */}
              {/* {capturedImage && <Grid2 sx={{ display: 'flex', justifyContent: "center", alignItems: "center", width: "300px", marginTop: "20px" }}>
            {isLoading ? <Box sx={{ width: '100%' }}>
              <LinearProgress />
            </Box> :
              <Typography>Liveness - {livelinessScore?.toFixed(2)}%</Typography>}
          </Grid2>} */}
              {error && !isQRMode && <Grid2 sx={{ display: 'flex', justifyContent: "space-between", alignItems: "center", marginTop: "20px" }}>
                <Typography sx={{ color: "red", textAlign: "center" }}>{errorMessage}</Typography>
              </Grid2>}
              {passed && <Grid2 sx={{ display: 'flex', justifyContent: "space-between", alignItems: "center", marginTop: "20px" }}>
                <Typography sx={{ color: "green" }}>Face Match Success</Typography>
              </Grid2>}
              {/* // With this: */}
              {/* {passed && <Grid2 sx={{ display: 'flex', justifyContent: "space-between", alignItems: "center", marginTop: "20px" }}>
            <Typography sx={{ color: "green" }}>Liveness Check Passed</Typography>
          </Grid2>} */}


              {/* <Grid2>
            <Button
              className={CaptureStyles1.skip_button}
              variant="outlined"
              onClick={() => console.log("Skip Now clicked")}
            >
              Skip Now
            </Button>
          </Grid2> */}

              {
                isSmallScreen ? <>
                  <Typography className={CaptureStyles1.footerText}>
                    Please allow LOCATION and CAMERA permissions when requested. You
                    need to do this only ONCE as per SEBI regulations, to open a Demat
                    account.
                  </Typography>
                  <Grid2 className={CaptureStyles1.but_card}>
                    <Grid2>

                      {!passed && <Button
                        className={CaptureStyles1.con_button}
                        onClick={handleCapture}
                        disabled={isLoading}
                      >
                        {capturedImage ? "Retake" : "Capture Photo"}
                      </Button>}
                      {passed && <Button className={CaptureStyles1.con_button}
                        onClick={() => setIsCompleted(true)}>
                        Continue
                      </Button>}
                      {/* {passed && <Typography className={SignatureStyles.txt} mt="20px" >
                        <span style={{ textDecoration: "underline", color: "blue", cursor: "pointer", fontSize: "16px" }} onClick={() => {
                          setIsCompleted(false)
                          setCapturedImage(null)
                          setPassed(false)
                        }}>Take Selfie again</span>
                      </Typography>} */}


                      {/* <Grid2 mt={2}>
                        <Button Button
                        className={CaptureStyles.skip_button}
                        variant="outlined"
                        onClick={handleSkipCS}
                      >
                        Skip Now
                      </Button>
                  </Grid2> */}
                    </Grid2>


                  </Grid2>
                </> : <>
                  <Grid2 className={CaptureStyles1.but_card}>

                    {!isQRMode && <Grid2>
                      {!passed && <Button
                        className={CaptureStyles1.con_button}
                        onClick={handleCapture}
                        disabled={isLoading}
                      >
                        {capturedImage ? "Retake" : "Capture Photo"}
                      </Button>}
                      {passed && <Button className={CaptureStyles1.con_button}
                        onClick={() => setIsCompleted(true)}>
                        Continue
                      </Button>}

                      {/* {passed && <Typography className={SignatureStyles.txt} mt="20px" >
                        <span style={{ textDecoration: "underline", color: "blue", cursor: "pointer", fontSize: "16px" }} onClick={() => {
                          setIsCompleted(false)
                          setCapturedImage(null)
                          setPassed(false)
                        }}>Take Selfie again</span>
                      </Typography>} */}

                    </Grid2>}
                    {!passed && <Button disabled={isLoading} onClick={handleGenerateQR} className={CaptureStyles1.con_button} sx={{
                      fontSize: "16px !important",
                      "@media screen and (max-width : 768px)": {
                        display: "none"
                      }
                    }}>
                      {isQRMode ? "Cancel" : "Capture on mobile"}
                    </Button>}
                    <br></br>


                  </Grid2>
                  {/* <Grid2 m={2}>
                    <Button
                        className={CaptureStyles.skip}
                        variant="outlined"
                        onClick={handleSkipCS}
                      >
                        Skip Now
                      </Button>
                    </Grid2> */}
                  {isQRMode && <Grid2>
                    <Typography className={SignatureStyles.txt} mt="20px" >
                      After you complete selfie on mobile please <span style={{ textDecoration: "underline", color: "blue", cursor: "pointer" }} onClick={() => setCheckStatus(!checkStatus)}>click here</span> to continue
                    </Typography>
                    {errorMessage && <Typography className={SignatureStyles.upload_txt} sx={{ fontSize: "14px", color: "red !important", textAlign: "center", mt: "10px" }}>
                      {errorMessage}
                    </Typography>}
                  </Grid2>}
                  {!isQRMode && <Typography className={CaptureStyles1.footerText}>
                    Please allow LOCATION and CAMERA permissions when requested. You
                    need to do this only ONCE as per SEBI regulations, to open a Demat
                    account.
                  </Typography>}
                </>
              }


              <Box className={CaptureStyles1.card} mt="20px">
                <img
                  src={icon} // Replace with your image URL
                  alt="Checkmark"
                  className={CaptureStyles1.icon}
                />
                <Typography className={CaptureStyles1.txt}>
                  Your account details are safe & secure with us.
                </Typography>
              </Box>

            </Box> : <Box className={CaptureStyles.outer}>
              <Box sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                position: 'relative',
                width: '100%',
                marginBottom: '10px',
                marginTop: '10px',
              }}>
                {/* Back arrow button - only shows below 1000px */}
                {/* <Box sx={{
                  position: 'absolute',
                  left: 0,

                  '@media (min-width: 1000px)': {
                    display: 'none' // Explicitly hide above 1000px
                  }
                }}>
                  <IconButton
                    onClick={() => navigate('/step-6')} // Or your custom back handler
                    sx={{
                      color: '#000', // Customize color
                      padding: '16px'
                    }}
                  >
                    <ArrowBack /> 
                  </IconButton>
                </Box> */}

                {/* Logo - centered */}
                <img
                  src={navLogo}
                  alt="Logo"
                  style={{
                    // Adjust margin to account for arrow on mobile
                    marginLeft: { xs: '40px', md: 0 }
                  }}
                  className={CaptureStyles.nav_logo}
                />
              </Box>

              <Typography className={CaptureStyles.title}>Capture Photo</Typography>
              <Typography className={CaptureStyles.subtitle}>
                Click a selfie for your KYC verification.
              </Typography>

              <Grid2 className={CaptureStyles.card}>
                {/* Left Column - Image */}
                <Grid2>
                  <Box className={CaptureStyles.imageContainer}>
                    <img
                      src={img}
                      alt="Selfie Example"
                      className={CaptureStyles.image}
                    />
                  </Box>
                </Grid2>

                {/* Right Column - Content */}
                <Grid2>
                  <Box className={CaptureStyles.instructions}>
                    <Typography className={CaptureStyles.instruction}>
                      <span className={CaptureStyles.number}>1. </span>
                      Ensure Good Lighting – Take the selfie in a well-lit area for
                      clear visibility.
                    </Typography>
                    <Typography className={CaptureStyles.instruction}>
                      <span className={CaptureStyles.number}>2. </span>
                      Face the Camera Directly – Look straight at the camera with
                      a neutral expression or slight smile.
                    </Typography>
                    <Typography className={CaptureStyles.instruction}>
                      <span className={CaptureStyles.number}>3. </span>
                      No Accessories – Remove hats, sunglasses, or anything that
                      obstructs your face.
                    </Typography>
                    <Typography className={CaptureStyles.instruction}>
                      <span className={CaptureStyles.number}>4. </span>
                      Avoid Blurry Images – Ensure the photo is sharp, with no
                      filters or edits.
                    </Typography>
                  </Box>
                </Grid2>
              </Grid2>

              {

                isSmallScreen ?
                  <>
                    <Typography className={CaptureStyles.footerText}>
                      Please allow LOCATION and CAMERA permissions when requested. You
                      need to do this only ONCE as per SEBI regulations, to open a Demat
                      account.
                    </Typography>
                    <Grid2
                      container
                      mt={3}
                      direction={{ xs: "column-reverse", md: "row" }}
                      spacing={1}
                    >
                      {/* <Grid2 mb={2}>
                      <Button
                        className={CaptureStyles.skip_button}
                        variant="outlined"
                        onClick={handleSkipCS}
                      >
                        Skip Now
                      </Button>
                    </Grid2> */}

                      <Grid2 >
                        <Button
                          onClick={() => setOpenCamera(true)}
                          className={CaptureStyles.con_button}
                        >
                          Open Camera
                        </Button>
                      </Grid2>
                    </Grid2>

                  </> :
                  <>
                    <Grid2 className={CaptureStyles.but_card}>
                      {/* <Grid2>
                            <Button
                                    className={CaptureStyles.skip_button}
                                    variant="outlined"
                                   onClick={handleSkipCS}
                                >
                                    Skip Now
                                </Button>
                            </Grid2> */}
                      <Grid2>
                        <Button onClick={() => setOpenCamera(true)} className={CaptureStyles.con_button}>Open Camera</Button>
                      </Grid2>
                    </Grid2>

                  </>
              }


              <Box className={CaptureStyles.card}>
                <img
                  src={icon} // Replace with your image URL
                  alt="Checkmark"
                  className={CaptureStyles.icon}
                />
                <Typography className={CaptureStyles.txt}>
                  Your account details are safe & secure with us.
                </Typography>
              </Box>
            </Box>}

          </>}
        </Box> 

        
    </>
    
  );
}
